import React, { Fragment } from 'react'
import styled from 'styled-components'

import Price from '../../atoms/ApartmentCardVersion2/Price'
import Bedrooms from '../../atoms/ApartmentCardVersion2/Bedrooms'
import { getBedroomsWithMinPrice } from '../../helpers'

const PriceSummaryContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.isGrid ? 'row' : 'column')};
  justify-content: ${props => (props.isGrid ? 'space-between' : undefined)};
  margin-top: ${props => (props.isGrid ? (!props.hasAmenities ? '40px' : '24px') : undefined)};
  width: 100%;
`

const NoPricing = styled.div`
  flex: 1;
  display: flex;
  justify-content: ${props => props.isGrid ? 'flex-end' : 'flex-start'};
  align-items: flex-end;
  color: #666666;
  font-size: 0.8em;
  width: 100%;
`

const PriceSummary = ({ isGrid, priceSummary, hasAmenities }) => {
  const { startingPrice, bedrooms: startingPriceBedroom } = getBedroomsWithMinPrice(priceSummary)

  return startingPrice ? (
    <PriceSummaryContainer isGrid={isGrid} hasAmenities={hasAmenities}>
      {isGrid ? (
        <Fragment>
          <Price
            startingPrice={startingPrice}
            startingPriceBedroom={startingPriceBedroom}
            isGrid={isGrid}
          />
          <Bedrooms bedrooms={priceSummary.map(unit => unit.bedrooms)} isGrid={isGrid} />
        </Fragment>
      ) : (
        <Fragment>
          <Bedrooms bedrooms={priceSummary.map(unit => unit.bedrooms)} isGrid={isGrid} />
          <Price startingPrice={startingPrice} isGrid={isGrid} />
        </Fragment>
      )}
    </PriceSummaryContainer>
  ) : <NoPricing isGrid={isGrid}>Visit website for pricing</NoPricing>
}

export default PriceSummary
